<app-context-menu-button [actions]="userActions" [positionPreference]="'bottomLeft'"
                         (onActionClicked)="handleUserAction($event)">
</app-context-menu-button>
